import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <footer
      class="bg-light-primary dark:bg-dark-secondary border-t border-light-border dark:border-dark-border py-6 mt-8"
    >
      <div class="container mx-auto px-4">
        <div class="text-center text-gray-600 dark:text-gray-400">
          <p>© 2025 Fact Check Trump. All rights reserved.</p>
          <div class="mt-4 flex justify-center space-x-4 text-sm">
            <a
              routerLink="/privacy-policy"
              class="hover:text-blue-500 hover:underline"
              >Privacy Policy</a
            >
            <a
              routerLink="/terms-of-service"
              class="hover:text-blue-500 hover:underline"
              >Terms of Service</a
            >
          </div>
        </div>
      </div>
    </footer>
  `,
  styles: [],
})
export class FooterComponent {}
